import {
  apiAddSendByteWallet,
  apiDeleteSendByteWallet,
  apiUpdateSendByteWallet,
} from "@lib/api/walletSendByte";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useSendByteWalletQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages } = props;
  const queryKeys = queryKey || [
    "sendbyte-wallet",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const addSendByteWalletMutation = useMutation({
    mutationFn: apiAddSendByteWallet,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateSendByteWalletMutation = useMutation({
    mutationFn: apiUpdateSendByteWallet,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteSendByteWalletMutation = useMutation({
    mutationFn: apiDeleteSendByteWallet,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    addSendByteWalletMutation,
    updateSendByteWalletMutation,
    deleteSendByteWalletMutation,
  };
};
